import { Button } from "@/components/ui/button";

interface TaskFormActionsProps {
  loading: boolean;
  editingTaskId?: string | null;
  onClose: () => void;
}

const TaskFormActions = ({ loading, editingTaskId, onClose }: TaskFormActionsProps) => {
  return (
    <div className="flex justify-end space-x-2 pt-4">
      <Button type="button" variant="outline" onClick={onClose}>
        Annuller
      </Button>
      <Button type="submit" disabled={loading}>
        {loading ? (editingTaskId ? "Opdaterer..." : "Opretter...") : (editingTaskId ? "Opdater opgave" : "Opret opgave")}
      </Button>
    </div>
  );
};

export default TaskFormActions;